<template>
  <div>
    <div id="televersement__errors" class="pb-1 pr-1 row d-none">
      <div class="d-inline-flex col">
        <div class="cercleErreur cercleErreur-televersement mr-1">
          <span class="cercleErreur-contenu">!</span>
        </div>
        <div class="d-flex">
          <ul class="pl-0 m-0 d-inline-block">
            <li id="error-filesMultiple" class="televersementInvalide d-none"></li>

            <li id="error-type" class="televersementInvalide d-none"></li>

            <li id="error-size" class="televersementInvalide d-none"></li>

            <li id="error-identical-name" class="televersementInvalide d-none"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixinMessageErreur from '@/mixins/mixinMessageErreur';

export default {
  name: 'TeleversementErrors',
  mixins: [mixinMessageErreur],
  data() {
    return {
      codeErreur: {
        multiplesFichier: this.$i18n.t('validations.televersement.multiplesFichier'),
        format: this.$i18n.t('validations.televersement.format'),
        grandeur: this.$i18n.t('validations.televersement.grandeur'),
        nomIdentique: this.$i18n.t('validations.televersement.nomIdentique'),
      },
      listIdErreur: ['error-filesMultiple', 'error-type', 'error-size', 'error-identical-name'],
    };
  },
  computed: {
    ...mapGetters(['getAccountUserMessages']),
  },
  mounted() {
    // TODO: Recoder en parcourant les éléments de "@nodes"
    let i = 0;
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in this.codeErreur) {
      this.mixinMessageErreur_getMessage(this.codeErreur[key], key, this.listIdErreur[i]);

      i++;
    }
  },
};
</script>
